import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Link, useLocation, useHistory } from "react-router-dom"
import {
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row,
  Card,
  CardImg,
  CardTitle,
  Modal,
} from "reactstrap"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import * as url from "helpers/url_helper"
import UgiftEmptyState from "./UgiftEmptyState"
import emptyImage from "assets/images/ugifts/icons/empty/empty_friend.png"
import emptyWechat from "assets/images/ugifts/icons/empty/empty_wechat.png"

// import images
import iconPaymentSuccess from "assets/images/ugifts/icons/checkout/icon_payment_success.png"
import iconPaymentFailed from "assets/images/ugifts/icons/checkout/icon_payment_failed.png"

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

function isWechat() {
  if (
    navigator.userAgent.toLowerCase().indexOf("micromessenger") > -1 ||
    typeof navigator.wxuserAgent !== "undefined"
  ) {
    return true
  } else return false
}

const TNC = () => {
  const query = useQuery()
  const history = useHistory()
  const isWechatBrowser = isWechat()

  const [token, setToken] = useState(null)

  useEffect(() => {
    if (localStorage.getItem("authAPI")) {
      const obj = JSON.parse(localStorage.getItem("authAPI"))
      console.log(
        "storage",
        obj.api_token_expiry + " / " + Math.floor(Date.now() / 1000)
      )
      if (obj.api_token_expiry < Math.floor(Date.now() / 1000)) {
        getToken()
      } else {
        setToken(obj)
      }
    } else {
      getToken()
    }
  }, [])

  const getToken = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "get_api_token")
    urlencoded.append("source", "web")
    urlencoded.append("api_key", process.env.REACT_APP_APIKEY)

    const requestOptions = {
      method: "POST",
      body: urlencoded,
    }

    console.log("Request token", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_POST_AUTH, requestOptions)
    const postresponse = await response.json()

    console.log(response.status, postresponse.message)

    if (response.status == 200 && postresponse.success) {
      setToken(postresponse)
      localStorage.setItem("authAPI", JSON.stringify(postresponse))
      console.log(response.status, token)
    } else {
      // seterror_alert(true)
    }
  }

  return (
    <React.Fragment>
      <div>
        <MetaTags>
          <title>Terms And Conditions | Ugift</title>
        </MetaTags>
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col
              xl={6}
              className="mx-auto"
              style={{
                maxWidth: "480px",
                backgroundColor: "white",
                // backgroundImage: `url(${bgImage})`,
                // backgroundSize: "cover",
              }}
            >
              {/* <img
                src={bgImage}
                alt=""
                style={{
                  position: "absolute",
                  objectFit: "contain",
                  maxWidth: "480px",
                }}
              /> */}
              <div
                className="auth-full-page-content"
                style={{
                  minHeight: "100vh",
                  paddingTop: "56px",
                  backgroundColor: "white",
                  // paddingBottom: "76px",
                }}
              >
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    {
                      <Row
                        className="m-0 w-100"
                        style={{
                          height: "56px",
                          backgroundColor: "#009FE2",
                          position: "fixed",
                          top: 0,
                          zIndex: 1030,
                          maxWidth: "480px",
                        }}
                      >
                        <Col xs={2} className="ps-0">
                          {/* <Link to="/categories"> */}
                          {/* <Button
                          className="h-100 m-0"
                          onClick={() => {
                            history.goBack()
                          }}
                        >
                          <i className="bx bx-arrow-back align-middle font-size-20 text-white" />
                        </Button> */}
                          {/* </Link> */}
                        </Col>
                        <Col xs={8} className="align-self-center">
                          <p className="h-100 text-white font-size-15 my-auto text-center">
                            {"App Terms & Conditions"}
                          </p>
                        </Col>
                        <Col xs={2} className="pe-0">
                          {/* <Link to="#">
                          <Button className="h-100 m-0">
                            <i className="bx bx-basket align-middle font-size-28 text-white" />
                          </Button>
                        </Link> */}
                        </Col>
                      </Row>
                    }
                    <div className="p-3">
                      <p>
                        <strong>App Terms &amp; Conditions&nbsp;</strong>
                      </p>
                      <p className="m-0">1. OWNERSHIP&nbsp;</p>
                      <p>
                        1.1 As used in this Agreement, &ldquo;e-Buy&rdquo;
                        refers e-Buy Information Technology Co Ltd. (including
                        all of its subsidiaries, brands, related and/or
                        associated companies/brands). &ldquo;Ugift&rdquo; refers
                        to this App or relate website."User" or "you" refers to
                        you.&nbsp;
                      </p>
                      <p>
                        USE OF THE SERVICES CONSTITUTES KNOWING ACCEPTANCE AND
                        ACKNOWLEDGEMENT OF THIS USER AGREEMENT AND TERMS AND
                        CONDITIONS.&nbsp;
                      </p>
                      <p>
                        1.2 We, e-Buy own this Ugift App or Ugift website
                        (ugiftglobal.com)and all its contents, including any and
                        all of its modules, the arrangement and compilation of
                        content, all trademarks and logos, information, text,
                        graphics, button icons, audio and video clips, digital
                        downloads, data compilations, software displayed on or
                        used in connection with this web site (collectively the
                        Content). You acknowledge and agree that you have no
                        right, title or interest (including without limitation
                        all copyright, trademarks and all other intellectual
                        property rights) in any of the Content and will not
                        challenge our ownership or right to use the Content on
                        this App .&nbsp;
                      </p>
                      <p className="m-0">2. USE OF UGIFT&nbsp;</p>
                      <p>
                        2.1 You shall not, except as permitted under applicable
                        law, modify, adapt, translate, decompile, alter,
                        disassemble, reverse engineer or create derivative works
                        from any Content or copy, reproduce, republish, upload,
                        post, transmit, distribute or otherwise communicate or
                        caused to be displayed to the public any Content without
                        our prior written permission. However, you may download,
                        display and print the materials displayed on this
                        website for your personal, non-commercial use.&nbsp;
                      </p>
                      <p>
                        2.2 You shall not use this website and/or any Content to
                        violate applicable copyright, trademark or other
                        intellectual property laws or other laws. You must
                        retain all copyright and trademark notices, including
                        any other proprietary notices, contained in the
                        materials, and you must not alter, obscure or obliterate
                        any of such notices.&nbsp;
                      </p>
                      <p>
                        2.3 You shall not employ misleading e-mail addresses or
                        falsify information in the header, footer, return path,
                        or any part of any communication, including short
                        message services (SMS) and/or electronic mails
                        (e-mails), transmitted through this website.&nbsp;
                      </p>
                      <p>
                        2.4 You shall not use any robot, spider crawler or any
                        other automated device, or a program, algorithm or
                        methodology having similar processes or functionality,
                        or any manual process, to monitor or copy any of the web
                        pages, data or content found on this web site, in any
                        case without our prior written permission.&nbsp;
                      </p>
                      <p>
                        2.5 You shall not take any action or otherwise use any
                        device, software or routine to interfere or attempt to
                        interfere with the proper working of this website.&nbsp;
                      </p>
                      <p>
                        2.6 You shall not take any action that imposes a burden
                        or load on our infrastructure that we deem in our sole
                        discretion to be unreasonable or disproportionate to the
                        benefits that we obtain from your use of this
                        website.&nbsp;
                      </p>
                      <p className="m-0">3 ELECTRONIC COMMUNICATIONS&nbsp;</p>
                      <p>
                        3.1 If you choose to register a user account with us,
                        submit your details, order or make any purchase of
                        products and services or send us e-mail or otherwise
                        communicate with us through this App or website, you
                        consent to receive electronic communications from us.
                        You agree that all agreements, notices, disclosures and
                        other communications that we provide you electronically
                        shall satisfy any legal requirements that such
                        communications be in writing.&nbsp;
                      </p>
                      <p className="m-0">4. THIRD PARTY LINKS&nbsp;</p>
                      <p>
                        4.1 This App or relate Website may contain links to
                        websites maintained by third parties. We do not control
                        such websites and accept no responsibility for them or
                        for the third parties, products or services. Your use of
                        any third party websites, products and services is
                        strictly at your own risk. We take no responsibility and
                        assume no liability for the information, content or
                        materials which you have provided to the third party
                        vendors.&nbsp;
                      </p>
                      <p>
                        4.2 Third party websites may also link to this website.
                        Such links do not necessarily mean that we are
                        associated or affiliated with or approve of the third
                        party vendors or its products and services. Please check
                        with us before relying on third party statements of
                        association or affiliation with us.&nbsp;
                      </p>
                      <p className="m-0">5. THIRD PARTY VENDORS&nbsp;</p>
                      <p>
                        5.1 We may use the services of third party vendors to
                        enable our customers to make orders, reservations,
                        delivery arrangements and payment online. You may be
                        directed to the website(s) of our third party vendors in
                        order to complete a transaction. These online services
                        are provided for your convenience. We take no
                        responsibility and assume no liability for the services
                        of any third party.&nbsp;
                      </p>
                      <p>
                        5.2 You are solely responsible for verifying directly
                        with the applicable third party vendors any information
                        on which you wish to rely. The purchase and use of a
                        third party vendor&rsquo;s products and services may
                        also be subject to the vendor&rsquo;s specific terms and
                        conditions, including without limitation terms and
                        conditions in relation to refunds, cancellations and
                        changes. You are solely responsible for verifying these
                        specific terms and conditions directly with the third
                        party vendor before purchasing or using its products or
                        services. In the event of any inconsistency between the
                        specific terms and conditions for products and services
                        of third party vendors and these Website Terms and
                        Conditions or any other Content, the specific terms and
                        conditions shall prevail in relation to those products
                        or services. In no event shall we be responsible for any
                        payments due to third parties in connection with your
                        purchase or use of their services.&nbsp;
                      </p>
                      <p className="m-0">
                        7. PRICES, PAYMENT, REFUNDS, RETURN &amp; EXCHANGE
                        POLICY&nbsp;
                      </p>
                      <p>
                        7.1 All prices displayed for products and services are
                        subject to change, and such prices are not final until
                        full payment for the product and service concerned is
                        made. Our products and services can change at any time
                        without notice. Other special conditions may
                        apply.&nbsp;
                      </p>
                      <p>
                        7.2 Sales are final and refunds, returns and exchanges
                        are generally not allowed but could be approved on a
                        strict case by case basis. For any enquiry around your
                        purchase you may reach out to us over email.
                      </p>
                      <p className="m-0">8. EVOUCHERS</p>
                      <p>
                        8.1 eVouchers which are available on this App or relate
                        website may be saved in the mobile as well as printed
                        and redeemed at vendors. These vouchers may not be
                        altered, changed or modified in any way. Your use of
                        eVouchers may be subject to additional terms and
                        conditions stated on the coupons or the eVoucher web
                        page in our App or relate Website.&nbsp;
                      </p>
                      <p className="m-0">9. DISCLAIMER&nbsp;</p>
                      <p>
                        This App and relate website including, all products or
                        services described or made available by means of this
                        App and relate website and all content are provided on
                        an as is and as available basis only and you use them at
                        your own risk. To the extent permitted by law, we
                        expressly disclaim all warranties in relation to any of
                        the foregoing, whether express, implied or arising by
                        statute or otherwise in law or from a course of dealing
                        or usage of trade, including without limitation any
                        warranties of merchantability, satisfactory quality,
                        fitness for any purpose, non-infringement, any
                        warranties as to the accuracy, completeness, currency or
                        reliability of the content (including user content) or
                        the security, authenticity, integrity or confidentiality
                        of any transactions and other communications made
                        through this website, and any warranties that this
                        website, its content, its servers or any e-mail sent
                        from us are free of viruses, trackers, bugs, worms, time
                        bombs, Trojan horses, trap doors or other codes designed
                        to permit unauthorized access, to disable, modify,
                        erase, damage, steal or usurp data or otherwise harm any
                        data or computer system or that the use of this website
                        or the content will not harm any data or computing
                        system. Some territories do not allow the disclaimer of
                        implied warranties, so to that extent the foregoing
                        disclaimer may not apply to you. This disclaimer shall
                        not in any way exclude or limit liability for personal
                        injury or death arising from negligence, willful
                        misconduct or fraud.&nbsp;
                      </p>
                      <p className="m-0">10. LIMITATION OF LIABILITY&nbsp;</p>
                      <p>
                        10.1 TO THE EXTENT PERMITTED BY LAW, WE SHALL IN NO
                        EVENT BE LIABLE FOR ANY INJURY, LOSS, CLAIM, DAMAGE, OR
                        ANY SPECIAL, EXEMPLARY, PUNITIVE, INDIRECT, INCIDENTAL
                        OR CONSEQUENTIAL DAMAGES OF ANY KIND OR FOR ANY LOST
                        PROFITS OR LOST SAVINGS, WHETHER BASED IN CONTRACT, TORT
                        (INCLUDING NEGLIGENCE), EQUITY, STRICT LIABILITY,
                        STATUTE OR OTHERWISE, EVEN IF WE HAVE BEEN ADVISED OF
                        THE POSSIBILITY OF SUCH LOSS OR DAMAGE. 10.2 TO THE
                        EXTENT PERMITTED BY LAW, OUR CUMULATIVE LIABILITY TO YOU
                        AND PERSONS CLAIMING THROUGH YOU SHALL IN NO EVENT
                        EXCEED THE VALUE OF THE PRODUCTS AND SERVICES PURCHASED
                        BY YOU BY MEANS OF THIS WEBSITE IN THE SIX (6) MONTHS
                        PRECEDING THE DATE OF YOUR CLAIM AGAINST US. FURTHER,
                        OUR LIABILITY TO YOU IN CONTRACT, TORT, NEGLIGENCE,
                        STRICT LIABILITY, UNDER STATUTE OR OTHERWISE WILL BE
                        REDUCED TO THE EXTENT, IF ANY, TO WHICH YOU CONTRIBUTED
                        TO THE LOSS OR DAMAGE. IN ITS SOLE DISCRETION, IN
                        ADDITION TO ANY OTHER RIGHTS OR REMEDIES AVAILABLE TO US
                        WITHOUT ANY LIABILITY WHATSOEVER, WE MAY, AT ANY TIME
                        AND WITHOUT NOTICE, TERMINATE OR RESTRICT YOUR ACCESS TO
                        AND/OR OF ANY COMPONENT OF THIS WEBSITE.&nbsp;
                      </p>
                      <p className="m-0">11. INDEMNIFICATION&nbsp;</p>
                      <p>
                        11.1 You shall indemnify, defend and hold harmless us
                        and our affiliates, subsidiaries and licensors, and our
                        respective officers, directors, employees and agents
                        from and against any and all losses, damages and
                        expenses of any kind (including reasonable legal and
                        accounting fees and costs) related to such claims,
                        actions or demands arising out of and in connection your
                        breach of these Website Terms and Conditions.&nbsp;
                      </p>
                      <p className="m-0">12. INJUNCTIVE RELIEF&nbsp;</p>
                      <p>
                        12.1 You acknowledge that a violation or attempted
                        violation of any of these Website Terms and Conditions
                        will cause us irreparable damage, the exact amount of
                        which would be difficult to ascertain and for which
                        there will be no adequate remedy at law. Accordingly,
                        you agree that we shall be entitled as a matter of right
                        to an injunction (including a temporary injunction)
                        issued by any court of competent jurisdiction,
                        restraining such violation or attempted violation of
                        these Website Terms and Conditions by you, or your
                        affiliates, partners, or agents, as well as recover from
                        you any and all costs and expenses sustained or incurred
                        by us in obtaining such an injunction, including,
                        without limitation, all legal fees and expenses.&nbsp;
                      </p>
                      <p className="m-0">13. MODIFICATION BY E-BUY</p>
                      <p>
                        13.1 We may at any time modify these Website Terms and
                        Conditions at our sole discretion without prior notice.
                        Your continued use of this website signifies your
                        acceptance of these Website Terms and Conditions in
                        force at the time of your use.&nbsp;
                      </p>
                      <p>
                        13.2 We may also, at our sole discretion without prior
                        notice, modify any part of this website, including the
                        Content and any products and services made available by
                        means of this website, and limit, suspend, revise,
                        withdraw or terminate this website or any of its
                        functionalities, or any offers relating to products or
                        services made on this website.&nbsp;
                      </p>
                      <p className="m-0">
                        14. GOVERNING LAW &amp; JURISDICTION&nbsp;
                      </p>
                      <p>
                        14.1 These Website Terms and Conditions and all disputes
                        arising out of or in connection with these Website Terms
                        and Conditions shall be governed by the laws of
                        Singapore without regard to conflicts of law provisions.
                        You hereby consent and submit to the non-exclusive
                        jurisdiction of the courts of Singapore.&nbsp;
                      </p>
                      <p className="m-0">15. GENERAL PROVISIONS&nbsp;</p>
                      <p>
                        15.1 These Website Terms and Conditions constitute the
                        entire agreement between you and us and supersede any
                        prior agreements.&nbsp;
                      </p>
                      <p>
                        15.2 This agreement is for the benefit of and binds you
                        and us and our respective successors and assigns. You
                        shall not assign your rights or transfer your
                        obligations and duties under this agreement to any third
                        party without our prior written consent. We may freely
                        assign our rights or transfer our obligations and duties
                        under this agreement.&nbsp;
                      </p>
                      <p>
                        15.3 No amendment of this agreement by you shall be
                        binding unless it was made in writing and signed by you
                        and us.&nbsp;
                      </p>
                      <p>
                        15.4 Any waiver of rights shall be in writing and shall
                        not prevent you or us from exercising the same or any
                        other right in future.&nbsp;
                      </p>
                      <p>
                        15.5 The invalidity, illegality or unenforceability of
                        any part of this agreement shall not affect the
                        validity, legality and enforceability of the other parts
                        of this agreement.&nbsp;
                      </p>
                      <p>
                        15.6 Nothing in this agreement creates a joint venture,
                        partnership, relationship of employment or agency
                        between you and us. You do not have authority to
                        contract on behalf of or bind e-Buy.&nbsp;
                      </p>
                      <p>
                        15.7 The rights and remedies under this agreement are
                        cumulative and not exclusive of any other right or
                        remedy provided by law or equity.&nbsp;
                      </p>
                      <p>
                        15.8 No third party shall have any right to enforce any
                        of these provisions under the Contracts (Right of Third
                        Party) Act (Cap.53B) or any other theory of law.&nbsp;
                      </p>
                      <p>
                        15.9 The headings used in these Website Terms and
                        Conditions are included for convenience only and will
                        not limit or otherwise affect the provisions
                        herein.&nbsp;
                      </p>
                      <p>
                        18. CONTACT Ugift or e-Buy should you have any queries
                        or require any further information on these Terms and
                        Conditions, please send us an e-mail to:
                        ugiftsupport@e-buy.com
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default TNC
